var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChargePhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "charge-phone_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#charge-phone_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M19.167 28.333v-6.666h-3.334l5-10v6.666h3.334l-5 10Zm-10.834 10V1.667h23.334v36.666H8.333Zm2.778-4.166v1.388H28.89v-1.388H11.11Zm0-2.778H28.89V8.61H11.11V31.39Zm0-25.556H28.89V4.445H11.11v1.388Z"
}))));
export default SvgChargePhone;